<template>
	<transition name="modal-fade">
		<div v-if="render" class="wk-modal" @click.self="clickOverlay">
			<div
				class="wk-modal-content"
				:style="`width:${width}; height:${height}; padding:${padding}; border-radius:${borderRadius}`"
			>
				<slot />
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',

	props: {
		closeButtonPosition: {
			type: String,
			default: '',
		},
		width: { type: String, default: '' },
		height: { type: String, default: '' },
		padding: { type: String, default: '30px' },
		overlayCanClose: { type: Boolean, default: false },
		borderRadius: { type: String, default: '8px' },
		render: { type: Boolean, required: true },
	},

	emits: ['close-modal'],

	methods: {
		closeModal() {
			this.$emit('close-modal', false)
		},

		clickOverlay(event) {
			if (this.overlayCanClose) {
				this.closeModal(event)
			}
		},
	},
}
</script>

<style scoped>
.wk-modal {
	position: fixed; /* Stay in place */
	z-index: 999; /* Sit on top */
	left: 0;
	top: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	overflow: auto; /* Enable scroll if needed */
	background-color: rgb(0, 0, 0); /* Fallback color */
	background-color: rgba(0, 0, 0, 0.2); /* Black w/ opacity */
	display: flex;
}

/* Modal Content/Box */
.wk-modal-content {
	background-color: #fefefe;
	margin: auto; /* 15% from the top and centered */
	padding: 10px;
	border-radius: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.5s ease;
}
</style>
